export enum PatternCategory {
  Blockchain = 'Blockchain',
  BusinessSoftware = 'BusinessSoftware',
  DataAndAnalytics = 'DataAndAnalytics',
  DesktopAndAppStreaming = 'DesktopAndAppStreaming',
  DeveloperTools = 'DeveloperTools',
  EnterpriseApplications = 'EnterpriseApplications',
  EnterpriseOperations = 'EnterpriseOperations',
  IoT = 'IoT',
  MachineLearning = 'Machine Learning',
  PlatformMigration = 'PlatformMigration',
  SoftwareInfrastructure = 'SoftwareInfrastructure',
  Solutions = 'Solutions',
  IndependentSoftwareVendor = 'IndependentSoftwareVendor',
  LifeCycle = 'LifeCycle',
  PatternAccreditation = 'PatternAccreditation',
  PatternProvenance = 'PatternProvenance',
  PatternType = 'PatternType',
}
